var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Input } from '@angular/core';
import { HubPlace } from '../../../models/hub/hub.place';
import { HubApiService } from '../../../services/hub.api.service';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../../../common/components/base.component';
import { MatDialogRef } from '@angular/material';
import { AlertifyService } from "../../../services/alertify.service";
import { ToggleAndDataSourceStore } from '../../../stores/hub.calendar.store';
import { EditPlaceCategoryModalActions } from "./edit.place.category.modal.provider";
import { PlaceCategorySelectorComponent } from "./place.category.selector/place.category.selector.component";
import { HubVisitorToggleDataSource } from "../../../models/hub/hub.visitor.feature.toggle";
import { PlaceService } from "../../../services/place.service";
import { VisitorApiService } from "../../../services/visitor.api.service";
var EditPlaceCategoryModalComponent = /** @class */ (function (_super) {
    __extends(EditPlaceCategoryModalComponent, _super);
    function EditPlaceCategoryModalComponent(dialogRef, actions, hubApiService, visitorApiService, imageService, alertify, toggleAndDataSourceStore, data) {
        var _this = _super.call(this) || this;
        _this.dialogRef = dialogRef;
        _this.actions = actions;
        _this.hubApiService = hubApiService;
        _this.visitorApiService = visitorApiService;
        _this.imageService = imageService;
        _this.alertify = alertify;
        _this.toggleAndDataSourceStore = toggleAndDataSourceStore;
        _this.isUseDefault = true;
        _this.clientPlaceCategories = [];
        _this.blockGooglePlaceCategories = [];
        _this.toggleAndSource = new HubVisitorToggleDataSource();
        _this.place = Object.assign({}, data);
        _this.hubName = _this.place.hubName;
        _this.loadCustomCategories();
        return _this;
    }
    EditPlaceCategoryModalComponent.prototype.remove = function (categoryTitle) {
        categoryTitle = PlaceService.toCategoryCode(categoryTitle);
        if (this.place.categoryList.indexOf(categoryTitle) >= 0) {
            this.place.categoryList = this.place.categoryList.filter(function (x) { return x !== categoryTitle; });
            this.place.category = this.place.categoryList.join(', ');
            var readable = this.place.categoryList.map(function (x) { return PlaceService.toReadableCategory(x); });
            this.place.categoryText = readable.join(', ');
        }
    };
    EditPlaceCategoryModalComponent.prototype.confirm = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log(this.place);
                this.actions.confirm(event, {
                    category: this.place.category,
                    categoryList: this.place.categoryList,
                    categoryText: this.place.categoryText
                });
                this.dialogRef.close();
                return [2 /*return*/];
            });
        });
    };
    EditPlaceCategoryModalComponent.prototype.close = function () {
        if (this.actions.cancel) {
            this.actions.cancel();
        }
        this.dialogRef.close();
    };
    EditPlaceCategoryModalComponent.prototype.loadCustomCategories = function () {
        var _this = this;
        this.visitorApiService.getCustomDefaultPlaceCategories(this.hubName).subscribe(function (customDefaultPlaceCategory) {
            console.log('category in create place', customDefaultPlaceCategory);
            _this.isUseDefault = customDefaultPlaceCategory.customDefaultPlaceCategory.useDefault;
            _this.clientPlaceCategories = customDefaultPlaceCategory.customDefaultPlaceCategory.customCategories;
            _this.toggleAndSource.toggle = customDefaultPlaceCategory.toggle;
            _this.toggleAndSource.dataSource.businessType = customDefaultPlaceCategory.dataSource.businessType;
            _this.mergedDefaultCategories = customDefaultPlaceCategory.mergedDefaultCategories.filter(function (x) { return x.forBusinessTypes.indexOf(_this.toggleAndSource.dataSource.businessType) >= 0; });
            _this.blockGooglePlaceCategories = customDefaultPlaceCategory.blockGooglePlaceCategories ?
                customDefaultPlaceCategory.blockGooglePlaceCategories.split(', ').map(function (x) { return PlaceService.toReadableCategory(x); }) : [];
            console.log('this.clientPlaceCategories', _this.clientPlaceCategories);
        });
    };
    EditPlaceCategoryModalComponent.prototype.isSelected = function (categoryTitle) {
        return this.place.categoryList.indexOf(categoryTitle) >= 0;
    };
    EditPlaceCategoryModalComponent.prototype.normalCategorySelected = function (categoryTitle) {
        categoryTitle = PlaceService.toCategoryCode(categoryTitle);
        if (this.place.categoryList.indexOf(categoryTitle) >= 0) {
            this.place.categoryList = this.place.categoryList.filter(function (x) { return x !== categoryTitle; });
        }
        else {
            this.place.categoryList.push(categoryTitle);
        }
        this.place.category = this.place.categoryList.join(', ');
        var readable = this.place.categoryList.map(function (x) { return PlaceService.toReadableCategory(x); });
        this.place.categoryText = readable.join(', ');
    };
    EditPlaceCategoryModalComponent.prototype.toReadable = function (code) {
        return PlaceService.toReadableCategory(code);
    };
    EditPlaceCategoryModalComponent.prototype.toCode = function (category) {
        return PlaceService.toCategoryCode(category);
    };
    return EditPlaceCategoryModalComponent;
}(BaseComponent));
export { EditPlaceCategoryModalComponent };



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/hub/edit.place.category.modal/edit.place.category.modal.component.ts.pre-build-optimizer.js